module.exports = __webpack_public_path__ + "img/BOMBA.c85ebd55.jpg";